import IncidentStore from './IncidentStore';

export default IncidentStore;